import * as React from "react";
import { useContext } from "react";
import styled from "styled-components";
import { SpdrClientViewModel } from "../../../ViewModel/SpdrClientViewModel";
import BaseCard from "../Cards/Card";
import { LeftSideBoldSpan, LeftSideRightSpan } from "../Cards/LeftSideStyle";
import { EditProjectContext } from "../../EditProjectContext";
import { RouteEditTab } from "../../RouteEditTab";
import { isFinished } from "./IsFinished";
import { isSelected } from "./IsSelected";
import SpdrDelete from "./SpdrDelete/SpdrDelete";
import { getIdOfSpdrOrPdsr } from "../../RightSide/LtlTab/GetIdOfSpdrOrPdsr";
import { CardDeletionProps } from "../Cards/CardDeletionProps";
import { ReadOnlyProps } from "../../ReadOnlyProps";
import { isRouteTabFtlAndProjectInSandbox } from "../isRouteTabFtlAndProjectInSandbox";

export type SpdrCardProps = {
  readonly spdr: SpdrClientViewModel;
};

function SpdrCard({
  spdr,
  deletionAllowed,
  setDeletionAllowed,
  isReadOnly,
}: SpdrCardProps & CardDeletionProps & ReadOnlyProps) {
  const { SupplierGsdb, PlantGsdb, DockCode, UsedInFtlRoutes } = spdr;

  const { project, routeEditTabSelected, selectedLtlSpdrOrPdsr, setSelectedLtlSpdrOrPdsr } =
    useContext(EditProjectContext);

  const handleClick = () => {
    switch (routeEditTabSelected) {
      case RouteEditTab.Ftl:
        return;
      case RouteEditTab.Ltl:
        handleLtlClick();
        return;
      default:
        throw new Error(`SpdrCard handleLtlClick not implemented for ${routeEditTabSelected}`);
    }
  };

  const handleLtlClick = () => {
    setSelectedLtlSpdrOrPdsr(spdr);
  };

  const $hasDeleteButton =
    isRouteTabFtlAndProjectInSandbox({
      selectedRouteTab: routeEditTabSelected,
      projectState: project.State,
    }) && !isReadOnly;
  const $isFinished = isFinished(project, spdr?.SpdrId);
  const $isSelectable = routeEditTabSelected === RouteEditTab.Ltl;
  const selectedSpdrId = getIdOfSpdrOrPdsr(selectedLtlSpdrOrPdsr);

  return (
    <BaseCard
      onClick={() => handleClick()}
      $isSelected={isSelected(routeEditTabSelected, selectedSpdrId, spdr?.SpdrId)}
      $isFinished={$isFinished}
      $hasDeleteButton={$hasDeleteButton}
      $isSelectable={$isSelectable}
    >
      <LeftSideBoldSpan>
        {SupplierGsdb} - {PlantGsdb} - {DockCode}
      </LeftSideBoldSpan>
      <LeftSideRightSpan>{UsedInFtlRoutes}</LeftSideRightSpan>
      <SpdrDelete
        spdr={spdr}
        noDeletionProcessCurrentlyRunning={deletionAllowed}
        setNoDeletionProcessCurrentlyRunning={setDeletionAllowed}
        disabled={isReadOnly}
      />
    </BaseCard>
  );
}

const StyledSpdrCard = styled(SpdrCard)`
  width: 240px;
`;

export default StyledSpdrCard;
